// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__rg-GO","info":"UpdateTermsInfo_info__15BTD"};